"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargeAbilityHandler = exports.ChargeActorAbilityFactory = exports.ChargeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ChargeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Charge;
        this.__typeName = "Charge";
    }
}
exports.ChargeAbilityArgs = ChargeAbilityArgs;
let ChargeActorAbilityFactory = class ChargeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Charge", "AllEnemies", 2);
    }
};
ChargeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Charge")
], ChargeActorAbilityFactory);
exports.ChargeActorAbilityFactory = ChargeActorAbilityFactory;
let ChargeAbilityHandler = class ChargeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: "Charge",
            attackType: "melee",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 100)
                ],
                effects: [
                    (0, Random_1.randomPercent)() <= 40 && {
                        targetId,
                        duration: Duration_1.Duration.Turns(1),
                        effect: new core_1.StunEffectArgs,
                    }
                ].filter(Boolean)
            }))
        });
    }
};
ChargeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Charge)
], ChargeAbilityHandler);
exports.ChargeAbilityHandler = ChargeAbilityHandler;
